// DEPENDENCIES
import React, { useState, useContext } from "react";

// CSS
import "./RFPFormLogDetails.css";

// MSAL
import { useMsal } from "@azure/msal-react";

// CONTEXT
import { UserContext } from "../../../../context/UserContext";

// MUI COMPONENTS
import {
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	TextField,
	Typography,
} from "@mui/material";

import { useEffect } from "react";
import {
	convertToPST,
	convertToPSTWithSeconds,
} from "../../../../constants/dateTime";
import { toTitleCase } from "../../../../constants/constants";

// MUI ICONS

// CUSTOM COMPONENTS

// CONSTANTS

// OTHER

// REACT COMPONENT
const RFPFormLogDetails = (props) => {
	// MSAL
	const { instance, accounts } = useMsal();

	// STATES
	const [isLoading, setIsLoading] = useState(true);

	// submission details
	const [id, setId] = useState(0);
	const [submitClickedTime, setSubmitClickedTime] = useState("");
	const [submittedTime, setSubmittedTime] = useState(0);
	const [submittedByEmployeeName, setSubmittedByEmployeeName] = useState("");
	const [errorMessage, setErrorMessage] = useState("");

	const [userEmailRetrievedTime, setUserEmailRetrievedTime] = useState(0);

	// client details
	const [clientLookupMode, setClientLookupMode] = useState("");
	const [clientFirstName, setClientFirstName] = useState("");
	const [clientLastName, setClientLastName] = useState("");
	const [clientEmail, setClientEmail] = useState("");
	const [clientHubSpotID, setClientHubSpotID] = useState("");
	const [clientHubspotCreatedFoundTime, setClientHubspotCreatedFoundTime] =
		useState(0);

	// property details
	const [propertyLookupMode, setPropertyLookupMode] = useState("");
	const [propertyName, setPropertyName] = useState("");
	const [propertyAddressLine1, setPropertyAddressLine1] = useState("");
	const [propertyAddressLine2, setPropertyAddressLine2] = useState("");
	const [propertyCity, setPropertyCity] = useState("");
	const [propertyState, setPropertyState] = useState("");
	const [propertyZip, setPropertyZip] = useState("");
	const [propertyHubSpotID, setPropertyHubSpotID] = useState("");
	const [
		propertyHubspotCreatedFoundTime,
		setPropertyHubspotCreatedFoundTime,
	] = useState(0);

	const [hubspotOwnerRetrievedTime, setHubspotOwnerRetrievedTime] =
		useState(0);

	const [service, setService] = useState("");
	const [specificComponent, setSpecificComponent] = useState("");

	const [hubspotDealCreatedTime, setHubspotDealCreatedTime] = useState(0);
	const [
		hubspotAssociateContactDealTime,
		setHubspotAssociateContactDealTime,
	] = useState(0);
	const [
		hubspotAssociatePropertyDealTime,
		setHubspotAssociatePropertyDealTime,
	] = useState(0);

	// proposal details
	const [proposalSource, setProposalSource] = useState("");
	const [scopeBackground, setScopeBackground] = useState("");
	const [additionalNotes, setAdditionalNotes] = useState("");
	const [buildingType, setBuildingType] = useState("");
	const [OIC, setOIC] = useState("");
	const [proposalDueDate, setProposalDueDate] = useState("");

	const [hubspotTaskCreatedTime, setHubspotTaskCreatedTime] = useState(0);
	const [hubspotAssociateTaskDealTime, setHubspotAssociateTaskDealTime] =
		useState(0);

	const [created, setCreated] = useState("");
	const [modified, setModified] = useState("");
	const [modifiedByName, setModifiedByName] = useState("");

	// CONTEXT
	const employeeID = useContext(UserContext);

	// USE EFFECT
	useEffect(() => {
		if (!props.open) return;

		setIsLoading(true);

		const r = props.recordToView ?? {};

		// submission details
		setId(r.id ?? "N/A");
		setSubmitClickedTime(r.submit_clicked_time ?? "N/A");
		setSubmittedTime(r.submitted_time ?? "N/A");
		setSubmittedByEmployeeName(r.submitted_by_employee_name ?? "N/A");
		setErrorMessage(r.error_message ?? "N/A");
		setUserEmailRetrievedTime(r.user_email_retrieved_time ?? "N/A");

		// client details
		setClientLookupMode(r.client_lookup_mode ?? "N/A");
		setClientFirstName(r.client_first_name ?? "N/A");
		setClientLastName(r.client_last_name ?? "N/A");
		setClientEmail(r.client_email ?? "N/A");
		setClientHubSpotID(r.client_hubspot_id ?? "N/A");
		setClientHubspotCreatedFoundTime(
			r.client_hubspot_created_found_time ?? "N/A"
		);

		// property details
		setPropertyLookupMode(r.property_lookup_mode ?? "N/A");
		setPropertyName(r.property_name ?? "N/A");
		setPropertyAddressLine1(r.property_address_line_1 ?? "N/A");
		setPropertyAddressLine2(r.property_address_line_2 ?? "N/A");
		setPropertyCity(r.property_city ?? "N/A");
		setPropertyState(r.property_state ?? "N/A");
		setPropertyZip(r.property_zip ?? "N/A");
		setPropertyHubSpotID(r.property_hubspot_id ?? "N/A");
		setPropertyHubspotCreatedFoundTime(
			r.property_hubspot_created_found_time ?? "N/A"
		);

		setHubspotOwnerRetrievedTime(r.hubspot_owner_retrieved_time ?? "N/A");

		setService(r.service ?? "N/A");
		setSpecificComponent(r.specific_component ?? "N/A");

		setHubspotDealCreatedTime(r.hubspot_deal_created_time ?? "N/A");
		setHubspotAssociateContactDealTime(
			r.hubspot_associate_contact_deal_time ?? "N/A"
		);
		setHubspotAssociatePropertyDealTime(
			r.hubspot_associate_property_deal_time ?? "N/A"
		);

		// proposal details
		setProposalSource(r.proposal_source ?? "N/A");
		setScopeBackground(r.scope_background ?? "N/A");
		setAdditionalNotes(r.additional_notes ?? "N/A");
		setBuildingType(r.building_type ?? "N/A");
		setOIC(r.oic ?? "N/A");
		setProposalDueDate(r.proposal_due_date ?? "N/A");

		setHubspotTaskCreatedTime(r.hubspot_task_created_time ?? "N/A");
		setHubspotAssociateTaskDealTime(
			r.hubspot_associate_task_deal_time ?? "N/A"
		);

		setCreated(r.created ?? "N/A");
		setModified(r.modified ?? "N/A");
		setModifiedByName(r.modified_by_name ?? "N/A");

		setIsLoading(false);
	}, [props.open, props.recordToView]);

	// HELPER FUNCTIONS
	const formClosed = () => {
		props.setOpen(false);
	};

	// RENDER
	return (
		<Dialog
			id="rfpFormLogDetailsDialog"
			open={props.open}
			fullWidth
			maxWidth="lg"
			onClose={formClosed}
		>
			<DialogTitle id="rfpFormLogDetailsDialogTitle">
				RFP Submission Details
			</DialogTitle>
			<DialogContent id="rfpFormLogDetailsDialogContent">
				{isLoading && (
					<div className="loadingSpinnerContainer">
						<CircularProgress color="primary" />
					</div>
				)}
				{!isLoading && (
					<>
						{/* Submission Details */}
						<Typography variant="h6" gutterBottom>
							Submission Details
						</Typography>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="id"
								label="RFP Form Log ID"
								value={id}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="submittedByEmployeeName"
								label="Submitted By Employee Name"
								value={submittedByEmployeeName}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								error={errorMessage !== "N/A"}
								id="errorMessage"
								label="Error Message"
								value={errorMessage}
								multiline
								minRows={2}
								disabled
							/>
						</div>

						<Divider />
						{/* Client Details */}
						<Typography variant="h6" gutterBottom>
							Client Details
						</Typography>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="clientLookupMode"
								label="Client Lookup Mode"
								value={toTitleCase(clientLookupMode)}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="clientHubSpotID"
								label="Client HubSpot ID"
								value={clientHubSpotID}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="clientHubspotCreatedFoundTime"
								label="Client HS Created/Found"
								value={
									clientHubspotCreatedFoundTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												clientHubspotCreatedFoundTime
										  )
								}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="clientFirstName"
								label="Client First Name"
								value={clientFirstName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="clientLastName"
								label="Client Last Name"
								value={clientLastName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="clientEmail"
								label="Client Email"
								value={clientEmail}
								disabled
							/>
						</div>

						<Divider />
						{/* Property Details */}
						<Typography variant="h6" gutterBottom>
							Property Details
						</Typography>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="propertyLookupMode"
								label="Property Lookup Mode"
								value={toTitleCase(propertyLookupMode)}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyHubSpotID"
								label="Property HubSpot ID"
								value={propertyHubSpotID}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyHubspotCreatedFoundTime"
								label="Property HS Created/Found"
								value={
									propertyHubspotCreatedFoundTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												propertyHubspotCreatedFoundTime
										  )
								}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="propertyName"
								label="Property Name"
								value={propertyName}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyCity"
								label="Property City"
								value={propertyCity}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyState"
								label="Property State"
								value={propertyState}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="propertyAddressLine1"
								label="Address Line 1"
								value={propertyAddressLine1}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyAddressLine2"
								label="Address Line 2"
								value={propertyAddressLine2}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="propertyZip"
								label="ZIP"
								value={propertyZip}
								disabled
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Proposal Details
						</Typography>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="proposalSource"
								label="Proposal Source"
								value={proposalSource}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="buildingType"
								label="Building Type"
								value={buildingType}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="oic"
								label="OIC"
								value={OIC}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="proposalDueDate"
								label="Proposal Due Date"
								value={
									proposalDueDate == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												proposalDueDate
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="service"
								label="Service"
								value={service}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="specificComponent"
								label="Specific Component"
								value={specificComponent}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="scopeBackground"
								label="Scope/Background"
								value={scopeBackground}
								disabled
								multiline
								minRows={2}
							/>
							<TextField
								sx={{ flex: 3 }}
								id="additionalNotes"
								label="Additional Notes"
								value={additionalNotes}
								disabled
								multiline
								minRows={2}
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Timestamps & Associations
						</Typography>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="submitClickedTime"
								label="Submit Clicked At"
								value={
									submitClickedTime === "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												submitClickedTime
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="userEmailRetrievedTime"
								label="User Email Retrieved"
								value={
									userEmailRetrievedTime === "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												userEmailRetrievedTime
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="hubspotOwnerRetrievedTime"
								label="HubSpot Owner Retrieved"
								value={
									hubspotOwnerRetrievedTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												hubspotOwnerRetrievedTime
										  )
								}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="hubspotDealCreatedTime"
								label="HubSpot Deal Created"
								value={
									hubspotDealCreatedTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												hubspotDealCreatedTime
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="hubspotAssociateContactDealTime"
								label="Associated HubSpot Contact→Deal"
								value={
									hubspotAssociateContactDealTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												hubspotAssociateContactDealTime
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="hubspotAssociatePropertyDealTime"
								label="Associated HubSpot Property→Deal"
								value={
									hubspotAssociatePropertyDealTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												hubspotAssociatePropertyDealTime
										  )
								}
								disabled
							/>
						</div>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="hubspotTaskCreatedTime"
								label="HubSpot Task Created"
								value={
									hubspotTaskCreatedTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												hubspotTaskCreatedTime
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="hubspotAssociateTaskDealTime"
								label="Associated HubSpot Task→Deal"
								value={
									hubspotAssociateTaskDealTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(
												hubspotAssociateTaskDealTime
										  )
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="submittedTime"
								label="Submitted At"
								value={
									submittedTime == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(submittedTime)
								}
								disabled
							/>
						</div>

						<Divider />
						<Typography variant="h6" gutterBottom>
							Audit
						</Typography>
						<div className="rfpFormLogDetailsDialogRow">
							<TextField
								sx={{ flex: 3 }}
								id="created"
								label="Created"
								value={
									created == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(created)
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="modified"
								label="Modified"
								value={
									modified == "N/A"
										? "N/A"
										: convertToPSTWithSeconds(modified)
								}
								disabled
							/>
							<TextField
								sx={{ flex: 3 }}
								id="modifiedByName"
								label="Modified By"
								value={modifiedByName}
								disabled
							/>
						</div>
					</>
				)}
			</DialogContent>
		</Dialog>
	);
};

// EXPORT
export default RFPFormLogDetails;
